// extracted by mini-css-extract-plugin
export default {"carousel":"bea","ingredient":"cea","swiper-pagination-bullet":"eea","swiper-pagination-bullet-active":"fea","swiper_carousel":"gea","swiper_pagination":"hea","arrows":"iea","arrow_navigation":"jea"};
    if(module.hot) {
      // 1721922369137
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  